import {
  VERIFICATION_SUCCEEDED,
  VERIFICATION_FAILED
} from "../constants/ActionTypes";

const verification = (state = { verified: false}, action) => {
  switch(action.type) {
    case VERIFICATION_SUCCEEDED:
      return {
        ...state,
        verified: {
          success: true,
          type: action.verification_type,
          url: action.url
        }
      };

    case VERIFICATION_FAILED: 
      return {
        ...state,
        verified: {
          success: false,
          type: action.verification_type
        }
      };

    default:
      return state;
  }
};

export default verification;
